import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Math$trunc from "@babel/runtime-corejs3/core-js/math/trunc";
export const inverseTypeView = typeView => {
  return typeView === "classic" ? "dynamic" : "classic";
};
export const clientProfileView = typeView => {
  return typeView || "classic";
};

/**
 * Transform a list of checklist items into a checklist component object
 */
export const checklistTransformAutomation = items => {
  items = _mapInstanceProperty(items).call(items, (item, index) => {
    item.index = index;
    return item;
  });
  const state = {
    items,
    percentCompleted: 0
  };
  const recalculatePercentage = (force = false) => {
    var _context;
    const completed = _filterInstanceProperty(_context = state.items).call(_context, item => item.completed).length;
    const total = state.items.length;
    const result = _Math$trunc(Math.round(completed * 100 / total)) || 0;
    state.newPercentCompleted = result;
    if (force) {
      state.percentCompleted = result;
    }
  };
  recalculatePercentage(true);
  return state;
};
export const checklistTransform = checklist => {
  var _context2;
  checklist.checklist = _mapInstanceProperty(_context2 = checklist.checklist).call(_context2, (item, index) => {
    item.index = index;
    return item;
  });
  const state = {
    items: checklist.checklist,
    id: checklist.id,
    percentCompleted: 0
  };
  const recalculatePercentage = (force = false) => {
    var _context3;
    const completed = _filterInstanceProperty(_context3 = state.items).call(_context3, item => item.completed).length;
    const total = state.items.length;
    const result = _Math$trunc(Math.round(completed * 100 / total)) || 0;
    state.newPercentCompleted = result;
    if (force) {
      state.percentCompleted = result;
    }
  };
  recalculatePercentage(true);
  return state;
};
export const registerHandlebarHelpers = Handlebars => {
  /**
   * Transform the list of items given by the backend to the format
   * used by the checklist component
   */
  Handlebars.registerHelper("checklistTransform", checklistTransform);
  Handlebars.registerHelper("inverseTypeView", inverseTypeView);
  Handlebars.registerHelper("clientProfileView", clientProfileView);
  /**
   * Transform a list of checklist items into a checklist component object
   */
  Handlebars.registerHelper("checklistTransformAutomation", checklistTransformAutomation);
};